import type { ReactNode } from 'react';
import { DealDrawer } from '@/features/pipeline/DealDrawer';
import { NewDealModal } from '@/features/pipeline/NewDealModal';
import { HandoffModal } from '@/features/portfolio/HandoffModal';
import { InvestmentDrawer } from '@/features/portfolio/InvestmentDrawer';
import { useInvestmentDrawer } from '@/features/portfolio/investmentDrawerStore';
import { EntityPeekModal } from '@/features/search/EntityPeekModal';
import { OriginadoraDrawer } from '@/features/origination/OriginadoraDrawer';
import { PersonDrawer } from '@/features/origination/PersonDrawer';
import { Toaster } from '@/components/ui/toast';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';

/** Shell autenticado: sidebar fixa + (topbar + conteúdo da rota) + host de toasts. */
export function AppLayout({ children }: { children: ReactNode }) {
  const investment = useInvestmentDrawer((s) => s.investment);
  const closeInvestment = useInvestmentDrawer((s) => s.closeInvestment);
  return (
    <div className="flex h-screen overflow-hidden bg-background text-foreground">
      <Sidebar />
      <div className="flex min-w-0 flex-1 flex-col">
        <Topbar />
        <main className="flex-1 overflow-auto">{children}</main>
      </div>
      <Toaster />
      <DealDrawer />
      <NewDealModal />
      <HandoffModal />
      <EntityPeekModal />
      <OriginadoraDrawer />
      <PersonDrawer />
      {investment && <InvestmentDrawer inv={investment} onClose={closeInvestment} />}
    </div>
  );
}
